<template>
  <v-container>
    <p>Sorry, we encountered a problem.</p>
    <template v-if="errorData!=null&&errorData.status!=null">
    <p class="text-overline">{{ errorData.status }}</p>
    <p class="text-overline">Contract ID: {{ errorData.contractId }}</p>
    <p class="text-overline">Access Key: {{ errorData.accessKey }}</p>
    </template>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'Default',
  computed: {
    ...mapGetters([
      'errorData',
    ]),
  },

  mounted() {
    console.log(process.env);
  },
};
</script>
